import { useCurrentCustomerId } from 'src/store';

import { NewProjectPromptWidget } from './NewProjectPromptWidget';
import { MainStoreContainer } from './store';

export const Container = (props) => {
  const currentCustomerId = useCurrentCustomerId();

  return (
    <MainStoreContainer currentCustomerId={currentCustomerId}>
      <NewProjectPromptWidget {...props} />
    </MainStoreContainer>
  );
};
